export default __webpack_public_path__ + "static/media/time_save_icon.2473750d.svg";